import React from 'react'
import {Field} from 'formik'

export const StarredField = props =>
  <Field {...props} placeholder={props.placeholder + '*'} title={props.title || I18n.t('misc.required_field')} />
